<template>
  <div>
    <div class="" v-for="attribute in attributes" :key="attribute.id">
      <div class="flex flex-row justify-center">
        <img :src="getAttributeImageURL(attribute.dispname)" />
      </div>
      <div class="grid md:grid-cols-4 grid-cols-1 gap-2">
        <div
          v-for="value in attribute.values"
          :key="value.id"
          class="p-2 border-4 border-black"
          style="background-color : #e3c3a0;"
        >
          <div class="flex flex-col ">
            <div class="border w-full">
              <img @click="() => imageClicked(value.index)" class="object-cover" :src="getImageURL(value)" />
            </div>
            <div class="flex flex-col justify-center items-center my-6 px-8">
              <div class="font-bold font-lg">{{ value.info }}</div>
              <div class="mx-16 w-full flex flex-row justify-between">
                <div>Amount</div>
                <div class="">{{ value.rarity.count }}</div>
              </div>
              <div class="mx-16 w-full flex flex-row justify-between">
                <div>Percentage</div>
                <div class="">{{ value.rarity.percentage }}%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['attributes'],
  data: function () {
    return {
        indexCounter: 0
    }
  },
  computed: {
  },
  mounted() {
      this.indexCounter = 0
  },
  methods: {
    imageClicked: function (index) {
        this.$emit('click', index)
    },
    getImageURL: (avalue) => {
      return 'https://fantomwheelz.com/assets/images/attributes/demo_' + avalue.id + '.png'
    },
    getAttributeImageURL: (disp) => {
      return (
        'https://fantomwheelz.com/assets/images/web_plate_' +
        disp.toLowerCase() +
        '_01.png'
      )
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/AttributeViewer.vue